import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { Product } from 'app/wipperoz-core/types/pricing/product.model';
import { filter, takeUntil } from 'rxjs/operators';
import { PricingService } from '../services/pricing.service';
import { IpLocationService } from 'app/wipperoz-core/services/ip-location.service';
import { WipperozGeolocationService } from 'app/wipperoz-core/services/location.service';
import { IpLocation } from 'app/wipperoz-core/types/location/ip-location.model';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PricingComponent implements OnInit, OnDestroy {
  products: Product[] = [];
  pricingImage =
    'https://cdn.sanity.io/images/jizm7zxy/production/1a237ab87d39c29cda3b3aa12b94c34325a05607-1920x1054.png?fm=webp&q=75';
  private unsubscribeAll: Subject<any>;
  constructor(
    private pricingService: PricingService,
    private ipLocationService: IpLocationService,
    private locationService: WipperozGeolocationService
  ) {
    this.unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    if (this.pricingService.products === undefined || this.pricingService.products.length === 0) {
      if (this.ipLocationService.ipLocationChanged !== undefined) {
        this.ipLocationService.ipLocationChanged
          .pipe(
            takeUntil(this.unsubscribeAll),
            filter((x: any) => {
              return x !== undefined && x.items !== undefined;
            })
          )
          .subscribe((data) => {
            const ipLocation = new IpLocation(data.items[0]);
            if (ipLocation.currencyCode !== undefined) {
              this.pricingService.getPlans().then((data) => {
                if (data !== null) {
                  this.products = data.sort((a, b) => {
                    return a.metadata.position - b.metadata.position;
                  });
                }
              });
            }
          });
      }
    } else {
      if (this.pricingService.products !== undefined || this.pricingService.products.length > 0) {
        this.products = this.pricingService.products;
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
  }
}
